export enum FilterActionType {
  EligibilityStatus = 'eligibilityStatus',
  PauseItem = 'pauseItem',
}

export const FILTER_LABEL_MAP: Record<FilterActionType, string> = {
  [FilterActionType.EligibilityStatus]: 'Ineligible item(s)',
  [FilterActionType.PauseItem]: 'Paused item(s)',
};

export const TOOLTIP_LABEL_MAP: Record<FilterActionType, string> = {
  [FilterActionType.EligibilityStatus]: 'View only ineligible items',
  [FilterActionType.PauseItem]: 'View only paused items',
};
